import { useMutation } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_PROCUREMENT } from "../domain";

import { procurementFileManagementApi } from "@api/services";
import { roleGuard } from "@api";
import { triggerDownloadFile } from "@helpers";

export const ACTION_DOWNLOAD_SUPPLIER_REPORT = "DOWNLOAD_SUPPLIER_REPORT";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

interface DownloadSupplierReportRequest {
  path: string;
  name: string;
}

const downloadSupplierReport = async ({
  path,
  name,
}: DownloadSupplierReportRequest): Promise<void> => {
  const response =
    await procurementFileManagementApi.procurementFileManagementControllerDownloadSupplierFile(
      path,
      {
        responseType: "blob",
      },
    );

  return triggerDownloadFile(response.data, name);
};

export const useDownloadSupplierReport = (
  user: UserProfileDto | null,
): {
  downloadSupplierReport: ({
    path,
    name,
  }: DownloadSupplierReportRequest) => Promise<void>;
  downloadSupplierReportEnabled: boolean;
  isSuccessDownloadSupplierReport: boolean;
  isPendingDownloadSupplierReport: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_PROCUREMENT, ACTION_DOWNLOAD_SUPPLIER_REPORT],
    mutationFn: downloadSupplierReport,
  });

  return {
    downloadSupplierReport: mutateAsync,
    downloadSupplierReportEnabled: enabled,
    isSuccessDownloadSupplierReport: isSuccess,
    isPendingDownloadSupplierReport: isPending,
  };
};
